import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import SearchIcon from '@mui/icons-material/Search';
import Business from '@mui/icons-material/Business';
import Person from '@mui/icons-material/Person';
import Movie from '@mui/icons-material/Movie';
import SchoolIcon from '@mui/icons-material/School';

import classes from './SearchSuggestions.module.css';

const SearchSuggestions = props => {
  const handleClose = () => {
    props.closeMenu();
  };

  return (
    props.searchInfo.data.response && (
      <>
        {props.searchInfo.data.response.length > 0 && (
          <Menu
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left'
            }}
            className={classes.suggestionsMenuContainer}
            id="basic-menu"
            open={props.openMenu}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button'
            }}
          >
            <MenuItem
              className={classes.itemSuggestion}
              component={Link}
              to={`/search/${props.searchText}`}
              onClick={handleClose}
            >
              <SearchIcon className={classes.suggestIcon} />{' '}
              {props.searchText}
            </MenuItem>
            {props.searchInfo.data.response.map(suggestion => (
              <MenuItem
                className={classes.itemSuggestion}
                component={Link}
                to={
                  suggestion.objeto === 2
                    ? `/c/${suggestion.idObjeto}`
                    : `/f/${suggestion.idObjeto}/${suggestion.idLista}`
                }
                key={suggestion.idObjeto}
              >
                {suggestion.objeto === 1 ? (
                  <Business className={classes.suggestIcon} />
                ) : suggestion.objeto === 2 ? (
                  <SchoolIcon className={classes.suggestIcon} />
                ) : suggestion.objeto === 3 ? (
                  <Person className={classes.suggestIcon} />
                ) : (
                  <Movie className={classes.suggestIcon} />
                )}
                {suggestion.titulo}
              </MenuItem>
            ))}
          </Menu>
        )}
      </>
    )
  );
};

SearchSuggestions.propTypes = {
  // eslint-disable-next-line react/require-default-props
  openMenu: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  searchInfo: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  closeMenu: PropTypes.function,
  // eslint-disable-next-line react/require-default-props
  searchText: PropTypes.string
};

export default SearchSuggestions;
